import { useMemo } from 'react';

import { useDashboardOverviewQuery } from '../api';
import { isDashboardResponseScopeMatch } from '../helpers/dashboardScope';
import { buildDashboardMetrics } from '../helpers/dashboardPresentation';
import { buildDashboardViewModel } from '../helpers/dashboardViewModel';

type TUseDashboardOverviewDataOptions = {
  selectedRootIds?: string[];
};

const EMPTY_SELECTED_ROOT_IDS: string[] = [];

export const useDashboardOverviewData = ({
  selectedRootIds = EMPTY_SELECTED_ROOT_IDS,
}: TUseDashboardOverviewDataOptions = {}) => {
  const query = useDashboardOverviewQuery({
    rootIds: selectedRootIds,
  });
  const responseMatchesSelection = isDashboardResponseScopeMatch(query.data?.scope, selectedRootIds);
  const response = query.isPlaceholderData || responseMatchesSelection ? query.data : undefined;
  const viewModel = useMemo(() => (response ? buildDashboardViewModel(response) : undefined), [response]);
  const metrics = useMemo(() => (viewModel ? buildDashboardMetrics(viewModel.counters) : []), [viewModel]);

  return {
    rootOptions: viewModel?.rootOptions ?? [],
    viewModel,
    metrics,
    statusChart: viewModel?.statusChart ?? [],
    segments: viewModel?.segments ?? [],
    isFetching: query.isFetching,
    isPlaceholderData: query.isPlaceholderData,
    error: query.error,
    refetch: query.refetch,
  };
};
